import { Grid, Box, Typography } from '@mui/material';

import { DtmfButton } from './components/DtmfButton';
import { useDtmf } from './hooks/useDtmf';
import { DTMF_BUTTONS } from './constants';
import { dtmfDialerStyles } from './styles';

export const DtmfDialer = () => {
  const { input, handleButtonClick } = useDtmf();

  return (
    <Box sx={dtmfDialerStyles.container}>
      <Box
        sx={{
          direction: 'rtl',
          overflow: 'hidden',
        }}
      >
        <Typography align="center" variant="h5" color="primary.contrastText" sx={dtmfDialerStyles.display}>
          {input}
        </Typography>
      </Box>

      <Grid container sx={dtmfDialerStyles.grid}>
        {DTMF_BUTTONS.map((row) =>
          row.map((button) => (
            <Grid item xs={4} key={button.digit} sx={dtmfDialerStyles.gridItem}>
              <DtmfButton button={button} onClick={handleButtonClick} />
            </Grid>
          )),
        )}
      </Grid>
    </Box>
  );
};
